module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-500italic.84aebbdd4d3714f8826a028995f31816.woff";